export default __webpack_public_path__ + "static/media/poland.9b06a169.png";